"use client"

import styled from "@emotion/styled"
import Link from "next/link"
import { Container, Desktop, ImageContainer, LeftArrowShort, Mobile, NewText } from "ui"
import { sharedColors } from "ui/theme/colors"

const StyledDiv = styled.div`
  height: 587px;
    margin-top: 50px;
  ${(props) => props.theme.breakpoints.down("sm")} {
  margin-top: 20px;
    p {
      width: 100%;
    }
  }
  ${(props) => props.theme.breakpoints.up("md")} {

    img {
      margin-top: 50px;
    }
  }
      ${(props) => props.theme.breakpoints.up("lg")} {
           height: 860px;
}
`

const StyledImageWrapper = styled.div`
      display: flex;
    justify-content: center;
      ${(props) => props.theme.breakpoints.down("sm")} {
    padding-top: 80px;
  }
`
const StyledLink = styled(Link)`
    display: flex;
    align-items: center;
    gap: 2px;
    color: #0050C9;
    font-weight: 500;
    text-decoration: none;
    :hover{
        text-decoration: underline;
    }
    padding-top: 20px;
`

type Props = {
    text: string
    imageDesktop: string
    imageMobile: string
    imageWidth: number
    imageHeight: number
}

function MessagePageCharge({
    text,
    imageDesktop,
    imageMobile,
}: Props) {

    return (
        <Container>
            <StyledDiv>
                <Mobile>
                    <NewText
                        component={"p"}
                        desktopFontSize={24}
                        desktopFontWeight={500}
                        desktopLineHeight={"26px"}
                        mobileLineHeight={"34px"}
                    >
                        {text.split(" ")[0]}
                        <br />
                        {text.split(" ").slice(1).join(" ")}
                    </NewText>
                </Mobile>
                <Desktop>
                    <NewText
                        component={"p"}
                        desktopFontSize={34}
                        desktopFontWeight={500}
                        desktopLineHeight={"36px"}
                        mobileFontSize={28}
                        mobileLineHeight={"34px"}
                        mobileFontWeight={500}
                    >
                        {text}
                    </NewText>
                </Desktop>
                <StyledLink href={"/pazcharge"} color={sharedColors.blue}>
                    לעמוד הבית
                    <LeftArrowShort color={sharedColors.blue}></LeftArrowShort>
                </StyledLink>
                <StyledImageWrapper>
                    <ImageContainer
                        desktopUrl={imageDesktop}
                        mobileUrl={imageMobile}
                        width={616}
                        height={460}
                        mobileHeight={225}
                        mobileWidth={345}
                    ></ImageContainer>
                </StyledImageWrapper>
            </StyledDiv>
        </Container>
    )
}

export default MessagePageCharge
